import { render, staticRenderFns } from "./DepresiasiClosePeriode.vue?vue&type=template&id=06f12126&"
import script from "./DepresiasiClosePeriode.vue?vue&type=script&lang=ts&"
export * from "./DepresiasiClosePeriode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f12126')) {
      api.createRecord('06f12126', component.options)
    } else {
      api.reload('06f12126', component.options)
    }
    module.hot.accept("./DepresiasiClosePeriode.vue?vue&type=template&id=06f12126&", function () {
      api.rerender('06f12126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/DepresiasiClosePeriode.vue"
export default component.exports